import type { InvestorContactCreateData } from '@/types/investor';
import { getPhoneError, isValidEmail } from '@/utils/validation';

export interface InvestorContactFormErrors {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  mobile?: string;
}

export const EMPTY_CONTACT_FORM_DATA: InvestorContactCreateData = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  mobile: '',
  role: 'contact_person',
  title: '',
  department: '',
  is_primary: false,
  is_authorized_signatory: false,
  receives_reports: true,
  receives_capital_calls: true,
  receives_distributions: true,
  portal_role_id: null,
  address_line_1: '',
  address_line_2: '',
  city: '',
  postcode: '',
  country: '',
};

export function validateContactForm(
  formData: InvestorContactCreateData
): InvestorContactFormErrors {
  const newErrors: InvestorContactFormErrors = {};

  if (!formData.first_name.trim()) {
    newErrors.first_name = 'First name is required';
  }
  if (!formData.last_name.trim()) {
    newErrors.last_name = 'Last name is required';
  }
  if (!formData.email?.trim()) {
    newErrors.email = 'Email is required';
  } else if (!isValidEmail(formData.email)) {
    newErrors.email = 'Please enter a valid email address';
  }
  const phoneError = getPhoneError(formData.phone);
  if (phoneError) {
    newErrors.phone = phoneError;
  }
  const mobileError = getPhoneError(formData.mobile);
  if (mobileError) {
    newErrors.mobile = mobileError;
  }

  return newErrors;
}
